import { Dispatch, SetStateAction } from 'react';
import { SEOSeniorCareSubServices, SEOSegmentationFilterInput } from '@/__generated__/globalTypes';
import { MultiSelectPills } from '../../MultiSelectPills';

type CanHelpWithProps = {
  canHelpWithServices: SEOSegmentationFilterInput['seniorCareSubServices'];
  setCanHelpWithServices: Dispatch<
    SetStateAction<SEOSegmentationFilterInput['seniorCareSubServices']>
  >;
};

const CanHelpWith = ({ canHelpWithServices, setCanHelpWithServices }: CanHelpWithProps) => {
  const seniorCareSubServicesOptions = [
    { label: 'Companionship', value: SEOSeniorCareSubServices.COMPANIONSHIP },
    { label: 'Mobility assistance', value: SEOSeniorCareSubServices.MOBILITY_ASSISTANCE },
    { label: 'Personal care', value: SEOSeniorCareSubServices.PERSONAL_CARE },
    { label: 'Specialized care', value: SEOSeniorCareSubServices.SPECIALIZED_CARE },
    { label: 'Transportation', value: SEOSeniorCareSubServices.TRANSPORTATION },
  ];

  const handleOnChangeEvent = (values: SEOSeniorCareSubServices[]) => {
    // Dementia exists under "Professional skills" section on the UI, but is added to seniorCareSubServices
    if (canHelpWithServices && canHelpWithServices.includes(SEOSeniorCareSubServices.DEMENTIA)) {
      setCanHelpWithServices(values.concat(SEOSeniorCareSubServices.DEMENTIA));
    } else {
      setCanHelpWithServices(values);
    }
  };

  return (
    <MultiSelectPills
      sectionName="Can help with"
      handleOnChangeEvent={handleOnChangeEvent}
      pillOptions={seniorCareSubServicesOptions}
      category="SENIOR_CARE_CAN_HELP_WITH"
      selectedValues={canHelpWithServices || []}
    />
  );
};

export { CanHelpWith };
